module.exports = __webpack_public_path__ + "static/img/prod3.7dde31d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prod3.png
// module id = fga7
// module chunks = 1